import type { RequiredAlertsListType } from '@nxsys/store/slices/dashboard/types';
import { EmployeeTabKey } from '../../../employees/detail/employeeTabKey';

/**
 * Maps a "missing field" alert to the detail tab + form field a user needs to
 * fill, so the dashboard popup can open the employee detail form in a drawer
 * (overlaid, no navigation) and focus the missing field directly (NX-4682).
 * Non-missing alerts (onHold / recurring) are absent here and keep "View".
 */
export const ALERT_EDIT_TARGET: Partial<
  Record<RequiredAlertsListType, { tab: EmployeeTabKey; field: string }>
> = {
  missingEmail: { tab: EmployeeTabKey.GENERAL_INFORMATION, field: 'email' },
  missingNINumber: {
    tab: EmployeeTabKey.GENERAL_INFORMATION,
    field: 'NINumber',
  },
  // Ireland's PPS is entered via the (relabeled) NINumber field on the Personal
  // Detail tab — setting.ppsNumber has no input of its own (NX-5443).
  missingPPSNumber: {
    tab: EmployeeTabKey.GENERAL_INFORMATION,
    field: 'NINumber',
  },
  missingAddress: { tab: EmployeeTabKey.ADDRESS, field: 'address1' },
};

export const isEditableAlert = (type: RequiredAlertsListType): boolean =>
  type in ALERT_EDIT_TARGET;
